import { Industry, Country, UserInfo } from "../../util/interfaces";

export enum AppActions {
  INIT_COMPLETE = '@@app/INIT_COMPLETE',
  SET_USER_INFO = '@@app/SET_USER_INFO',
  CLEAR_USER_INFO = '@@app/CLEAR_USER_INFO',
  SET_SIGNUP_TYPE = '@@app/SET_SIGNUP_TYPE',
  PARSE_PARAMS = '@@app/PARSE_PARAMS',
  REMOVE_PARAMS = '@@app/REMOVE_PARAMS',
  SUCCESS_CLAIM_INVOICE = '@@app/SUCCESS_CLAIM_INVOICE',
  FAILED_CLAIM_INVOICE = '@@app/FAILED_CLAIM_INVOICE',
  SET_IS_LOADING = '@@app/SET_IS_LOADING',
  SET_EXTENDED_REGISTRATION_PARAMS = '@@app/SET_EXTENDED_REGISTRATION_PARAMS',
  SET_IS_BUSINESS_LOGIN = '@@app/SET_IS_BUSINESS_LOGIN',
  SET_INDUSTRIES = '@@app/SET_INDUSTRIES',
  SET_COUNTRIES = '@@app/SET_COUNTRIES'
}

interface InitComplete {
  type: typeof AppActions.INIT_COMPLETE
}
interface SetUserInfo {
  type: typeof AppActions.SET_USER_INFO,
  payload: UserInfo
}

interface ClearUserInfo {
  type: typeof AppActions.CLEAR_USER_INFO,
}

interface SetSignupType {
  type: typeof AppActions.SET_SIGNUP_TYPE,
  payload: string
}

interface ParseParams {
  type: typeof AppActions.PARSE_PARAMS,
  payload: string
}

interface RemoveParams {
  type: typeof AppActions.REMOVE_PARAMS,
  payload: string[]
}

interface SuccessClaimInvoice {
  type: typeof AppActions.SUCCESS_CLAIM_INVOICE,
}

interface FailedClaimInvoice {
  type: typeof AppActions.FAILED_CLAIM_INVOICE,
  payload: string
}

interface SetIsLoading {
  type: typeof AppActions.SET_IS_LOADING,
  payload: boolean
}

interface SetExtendedRegistrationParams {
  type: typeof AppActions.SET_EXTENDED_REGISTRATION_PARAMS,
  payload: { [key: string]: any};
}

interface SetIsBusinessLogin {
  type: typeof AppActions.SET_IS_BUSINESS_LOGIN,
  payload: boolean
};

interface SetIndustries {
  type: typeof AppActions.SET_INDUSTRIES,
  payload: Industry[]
};

interface SetCountries{
  type: typeof AppActions.SET_COUNTRIES,
  payload: Country[]
};

export type AppActionType =
  InitComplete |
  SetUserInfo |
  ClearUserInfo |
  SetSignupType |
  ParseParams |
  RemoveParams |
  SuccessClaimInvoice |
  FailedClaimInvoice |
  SetIsLoading |
  SetExtendedRegistrationParams |
  SetIsBusinessLogin |
  SetIndustries |
  SetCountries
